var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 144,
    viewBox: "0 0 142 144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.213)",
    stroke: "#D2D2D9",
    strokeWidth: 2.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EEF0F3",
    cx: 104.67,
    cy: 106.435,
    rx: 36.942,
    ry: 37.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 87.652v37.565M123.141 106.435H86.198M30.785 106.435h24.628M0 68.87h67.727M49.256 87.652v9.391c0 5.187-4.135 9.392-9.235 9.392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14 56.348V6.26c0-3.458-2.756-6.261-6.156-6.261H6.157C2.757 0 0 2.803 0 6.26v75.131c0 3.458 2.757 6.261 6.157 6.261h49.256"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestType);
export default __webpack_public_path__ + "static/media/request-type.6bda75fa9c4f2f6c4772b2fc79031b13.svg";
export { ForwardRef as ReactComponent };